import styled from 'styled-components';

import {
  Input as SemanticInput,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  background-color: white;
  border-radius: 4px;
  border: 1px solid #DEDEDF;
  display: flex;
  flex-direction: column;
  margin: 10px;
  padding: 20px;
  width: calc(100% - 550px);
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const Input = styled(SemanticInput)`
  &.ui.input input {
    font-size: 14px;
    color: ${(props) => props.theme.color.inputColor}
  }
  width: 400px;
`;

export const DragDropComponent = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  min-height: 135px;
  overflow: auto;
  width: 100%;
`;

export const Message = styled(TextLayoutComponent)`
  color: #8A94AA;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  width: 100%;
`;

export const FeedbackMessage = styled(TextLayoutComponent.Feedback)``;

export const ContainerPlayer = styled.div`
  padding: 20px 0;
  flex: 1;
`;
